import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hireRegistrationNextStep, setHireRegistrationFormData } from '../../redux/slice/commonSlice'
import { fetchSkills } from '../../redux/action/commonAction'
import HiringStep2 from '../../assets/hiring-page/hire-step-img2.png'
import Image from '../../components/general/Image'
import SkillCard from '../../components/hire-developer/SkillCard'
import DoubleStar from "../../assets/common/DoubleStar.svg"
import Button from '../../components/general/Button'
import { toast } from 'react-toastify'
import Select from '../../components/general/Select'

const SkillType = () => {
    const dispatch = useDispatch()
    const { isTechLoading, technologies } = useSelector(state => state.common.tech);
    const { hire_registration: { stepTwoData: { skills } } } = useSelector(state => state.common);
    const [activeTechs, setActiveTechs] = useState(new Set([]))

    useEffect(() => {
        if (!isTechLoading) return;
        dispatch(fetchSkills());
        // eslint-disable-next-line
    }, [isTechLoading])

    const skillOptions = useMemo(() => {
        return technologies.filter(tech => !activeTechs.has(tech.id)).map(tech => ({
            label: tech.name,
            value: tech.id
        }))
    }, [technologies, activeTechs, skills])


    const handleChange = (value, label, actionType = 'add') => {        
        const currentActiveTechs = new Set(activeTechs);      

        if(actionType === 'remove') {
            currentActiveTechs.delete(value)
        }
        else {
            currentActiveTechs.add(value)
        }

        setActiveTechs(currentActiveTechs)
        
        const hasSelectedSkill = skills.some(skill => skill.value === value)
        
        const payload = hasSelectedSkill ? skills?.filter(p => p.value != value) : [...skills, { label: label, value: value }]
        dispatch(setHireRegistrationFormData({
            formData: {
                skills: payload
            }
        }))
    }

    const handleSelectChange = (value, actionMeta) => {
        if(actionMeta.action === 'select-option') {
            const selectedValue = value.find(v => v.value === actionMeta.option.value);
            handleChange(selectedValue.value, selectedValue.label);        
        }
        else if(actionMeta.action === 'remove-value') {
            const removedValue = actionMeta.removedValue;
            handleChange(removedValue.value, removedValue.label, 'remove');
        }
    }

    const handleSubmit = () => {
        if(!skills.length) {
            toast.error('Please select at least one skill')
            return;
        }

        dispatch(hireRegistrationNextStep())
    }
    return (
        <div className="text-white py-[20px] lg:flex lg:justify-between lg:items-start lg:gap-[30px]">
            <div className="project-Image lg:w-[40%]">
                <figure>
                    <Image src={HiringStep2} alt="hire-step-img2" />
                </figure>
            </div>
            <div className="mt-[30px] lg:mt-0 lg:w-[55%]">
                <div className="text-[14px] text-primary-color">2/3</div>
                <h3 className="text-[30px] lg:text-[1.7rem] font-bold flex justify-start">
                    <span>Select the skills that matter most.</span>
                    <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block ml-[10px]" />
                </h3>
                <p className='text-primary-color text-[0.7rem]'> Select 1–3 now, tweak anytime later</p>

                <div className='mt-[20px]'>
                    <Select 
                        isMulti={true}
                        options={skillOptions}
                        value={skills.map(p => ({
                            label: p.label,
                            value: p.value
                        }))}
                        onChange={(value, actionMeta) => handleSelectChange(value, actionMeta)}
                    />
                </div>

                <div className='mt-[20px]'>
                    <h5 className="text-primary-color mb-[10px]">Skills</h5>
                    
                    <div className='lg:max-h-[200px] lg:overflow-y-auto'>
                        <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 lg:gap-[10px] gap-[10px] lg:justify-start'>
                            {
                                technologies.map((tech, index) => (
                                    <div key={index}>
                                        <SkillCard 
                                            extraClass='flex-col justify-center'
                                            onClick={() => handleChange(tech.id, tech.name, activeTechs.has(tech.id) ? 'remove' : 'add')} keyName={index} icon={tech.icon_details ? tech.icon_details.file : ''} name={tech.name} isActive={activeTechs.has(tech.id)} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <Button className='bg-primary-color text-black w-full md:w-[200px] lg:h-[50px] h-[40px] mt-[20px] rounded' disabled={!Boolean(skills.length)} onClick={handleSubmit}> Get Started </Button>
            </div>
        </div>

    )
}

export default SkillType